// import { useState } from 'react';
// import { Link, useNavigate, useSearchParams } from 'react-router-dom';
// import AuthLayout from './AuthLayout';
// import { TextField, PasswordField, SubmitButton, EMAIL_RE } from './FormFields';
// import { useAuth } from '../../auth/AuthContext';
// import { Mail, Lock, Phone, User, Box, Route, Check } from '../Icons';

// const roles = [
//   { value: 'sender', Icon: Box, title: 'Send items', text: 'Find travellers on my route' },
//   { value: 'traveller', Icon: Route, title: 'Travel & carry', text: 'Share my spare capacity' },
// ];

// const strengthLabels = ['Too weak', 'Weak', 'Fair', 'Good', 'Strong'];

// function passwordScore(pw) {
//   let score = 0;
//   if (pw.length >= 8) score++;
//   if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
//   if (/\d/.test(pw)) score++;
//   if (/[^A-Za-z0-9]/.test(pw)) score++;
//   return score;
// }

// export default function Register() {
//   const { register } = useAuth();
//   const navigate = useNavigate();
//   const [params] = useSearchParams();
//   const initialRole = params.get('role') === 'traveller' ? 'traveller' : 'sender';

//   const [form, setForm] = useState({
//     role: initialRole,
//     name: '',
//     email: '',
//     phone: '',
//     password: '',
//     confirm: '',
//     terms: false,
//   });
//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [formError, setFormError] = useState('');

//   const score = passwordScore(form.password);

//   const onChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
//     if (errors[name]) setErrors((er) => ({ ...er, [name]: undefined }));
//   };

//   const validate = () => {
//     const er = {};
//     if (form.name.trim().length < 2) er.name = 'Enter your full name.';
//     if (!EMAIL_RE.test(form.email.trim())) er.email = 'Enter a valid email address.';
//     if (!/^\+?[\d\s-]{7,16}$/.test(form.phone.trim())) er.phone = 'Enter a valid phone number.';
//     if (form.password.length < 8) er.password = 'Use at least 8 characters.';
//     else if (score < 3) er.password = 'Add a mix of upper and lower case letters, numbers or symbols.';
//     if (form.confirm !== form.password) er.confirm = 'Passwords do not match.';
//     if (!form.terms) er.terms = 'You need to accept the terms to continue.';
//     return er;
//   };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     setFormError('');
//     const er = validate();
//     setErrors(er);
//     if (Object.keys(er).length) return;

//     setLoading(true);
//     try {
//       await register({ role: form.role, name: form.name, email: form.email, phone: form.phone, password: form.password });
//       navigate('/login', {
//         state: { notice: 'Account created. Log in to continue.', email: form.email.trim() },
//       });
//     } catch (err) {
//       const fieldErrors = err.fieldErrors || {};
//       if (Object.keys(fieldErrors).length) setErrors((er) => ({ ...er, ...fieldErrors }));
//       setFormError(err.message || 'We could not create your account. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <AuthLayout
//       title="Create your account"
//       subtitle="Join as a sender, a traveller, or switch any time later."
//       footer={<>Already have an account? <Link to="/login">Log in</Link></>}
//     >
//       {formError && <div className="alert alert--error" role="alert">{formError}</div>}

//       <form className="auth__form" onSubmit={onSubmit} noValidate>
//         <fieldset className="roles">
//           <legend>I want to</legend>
//           {roles.map(({ value, Icon, title, text }) => (
//             <label key={value} className={`role ${form.role === value ? 'is-active' : ''}`}>
//               <input type="radio" name="role" value={value} checked={form.role === value} onChange={onChange} />
//               <span className="role__icon"><Icon width={20} height={20} /></span>
//               <span className="role__text">
//                 <strong>{title}</strong>
//                 <small>{text}</small>
//               </span>
//               <span className="role__check"><Check width={12} height={12} /></span>
//             </label>
//           ))}
//         </fieldset>

//         <TextField
//           id="name"
//           label="Full name"
//           icon={User}
//           placeholder="As shown on your ID"
//           autoComplete="name"
//           value={form.name}
//           onChange={onChange}
//           error={errors.name}
//         />

//         <div className="fld-row">
//           <TextField
//             id="email"
//             label="Email address"
//             type="email"
//             icon={Mail}
//             placeholder="you@example.com"
//             autoComplete="email"
//             value={form.email}
//             onChange={onChange}
//             error={errors.email}
//           />
//           <TextField
//             id="phone"
//             label="Phone number"
//             type="tel"
//             icon={Phone}
//             placeholder="+91 98200 00000"
//             autoComplete="tel"
//             value={form.phone}
//             onChange={onChange}
//             error={errors.phone}
//           />
//         </div>

//         <PasswordField
//           id="password"
//           label="Password"
//           icon={Lock}
//           placeholder="At least 8 characters"
//           autoComplete="new-password"
//           value={form.password}
//           onChange={onChange}
//           error={errors.password}
//         />
//         {form.password && (
//           <div className={`strength strength--${score}`} aria-live="polite">
//             <div className="strength__bars">
//               {[0, 1, 2, 3].map((i) => <i key={i} className={i < score ? 'on' : ''} />)}
//             </div>
//             <span>{strengthLabels[score]}</span>
//           </div>
//         )}

//         <PasswordField
//           id="confirm"
//           label="Confirm password"
//           icon={Lock}
//           placeholder="Re-enter your password"
//           autoComplete="new-password"
//           value={form.confirm}
//           onChange={onChange}
//           error={errors.confirm}
//         />

//         <div>
//           <label className={`checkbox ${errors.terms ? 'checkbox--error' : ''}`}>
//             <input type="checkbox" name="terms" checked={form.terms} onChange={onChange} />
//             <span className="checkbox__box"><Check width={12} height={12} /></span>
//             <span>
//               I agree to the <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</Link> and <Link to="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
//             </span>
//           </label>
//           {errors.terms && <p className="fld__error" role="alert">{errors.terms}</p>}
//         </div>

//         <p className="auth__note">
//           Your phone and email are never shown to other users. They are shared only after an admin
//           assigns a delivery.
//         </p>

//         <SubmitButton loading={loading}>{loading ? 'Creating account…' : 'Create account'}</SubmitButton>
//       </form>
//     </AuthLayout>
//   );
// }




import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import { TextField, PasswordField, SubmitButton, EMAIL_RE } from './FormFields';
import { useAuth } from '../../auth/AuthContext';
import { Mail, Lock, User, Box, Route, Check } from '../Icons';

const roles = [
  { value: 'sender', Icon: Box, title: 'Send items', text: 'Find travellers on my route' },
  { value: 'traveller', Icon: Route, title: 'Travel & carry', text: 'Share my spare capacity' },
];

const strengthLabels = ['Too weak', 'Weak', 'Fair', 'Good', 'Strong'];

function passwordScore(pw) {
  let score = 0;
  if (pw.length >= 8) score++;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) score++;
  if (/\d/.test(pw)) score++;
  if (/[^A-Za-z0-9]/.test(pw)) score++;
  return score;
}

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const initialRole = params.get('role') === 'traveller' ? 'traveller' : 'sender';

  const [form, setForm] = useState({
    role: initialRole,
    name: '',
    email: '',
    password: '',
    confirm: '',
    terms: false,
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [formError, setFormError] = useState('');

  const score = passwordScore(form.password);

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors((er) => ({ ...er, [name]: undefined }));
  };

  const validate = () => {
    const er = {};
    if (form.name.trim().length < 2) er.name = 'Enter your full name.';
    if (!EMAIL_RE.test(form.email.trim())) er.email = 'Enter a valid email address.';

    if (form.password.length < 8) er.password = 'Use at least 8 characters.';
    else if (score < 3) er.password = 'Add a mix of upper and lower case letters, numbers or symbols.';
    if (form.confirm !== form.password) er.confirm = 'Passwords do not match.';
    if (!form.terms) er.terms = 'You need to accept the terms to continue.';
    return er;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setFormError('');
    const er = validate();
    setErrors(er);
    if (Object.keys(er).length) return;

    setLoading(true);
    try {
      await register({ role: form.role, name: form.name, email: form.email, password: form.password });
      navigate('/login', {
        state: { notice: 'Account created. Log in to continue.', email: form.email.trim() },
      });
    } catch (err) {
      const fieldErrors = err.fieldErrors || {};
      if (Object.keys(fieldErrors).length) setErrors((er) => ({ ...er, ...fieldErrors }));
      setFormError(err.message || 'We could not create your account. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Join as a sender, a traveller, or switch any time later."
      footer={<>Already have an account? <Link to="/login">Log in</Link></>}
    >
      {formError && <div className="alert alert--error" role="alert">{formError}</div>}

      <form className="auth__form" onSubmit={onSubmit} noValidate>
        <fieldset className="roles">
          <legend>I want to</legend>
          {roles.map(({ value, Icon, title, text }) => (
            <label key={value} className={`role ${form.role === value ? 'is-active' : ''}`}>
              <input type="radio" name="role" value={value} checked={form.role === value} onChange={onChange} />
              <span className="role__icon"><Icon width={20} height={20} /></span>
              <span className="role__text">
                <strong>{title}</strong>
                <small>{text}</small>
              </span>
              <span className="role__check"><Check width={12} height={12} /></span>
            </label>
          ))}
        </fieldset>

        <TextField
          id="name"
          label="Full name"
          icon={User}
          placeholder="As shown on your ID"
          autoComplete="name"
          value={form.name}
          onChange={onChange}
          error={errors.name}
        />

        <TextField
          id="email"
          label="Email address"
          type="email"
          icon={Mail}
          placeholder="you@example.com"
          autoComplete="email"
          value={form.email}
          onChange={onChange}
          error={errors.email}
        />

        <PasswordField
          id="password"
          label="Password"
          icon={Lock}
          placeholder="At least 8 characters"
          autoComplete="new-password"
          value={form.password}
          onChange={onChange}
          error={errors.password}
        />
        {form.password && (
          <div className={`strength strength--${score}`} aria-live="polite">
            <div className="strength__bars">
              {[0, 1, 2, 3].map((i) => <i key={i} className={i < score ? 'on' : ''} />)}
            </div>
            <span>{strengthLabels[score]}</span>
          </div>
        )}

        <PasswordField
          id="confirm"
          label="Confirm password"
          icon={Lock}
          placeholder="Re-enter your password"
          autoComplete="new-password"
          value={form.confirm}
          onChange={onChange}
          error={errors.confirm}
        />

        <div>
          <label className={`checkbox ${errors.terms ? 'checkbox--error' : ''}`}>
            <input type="checkbox" name="terms" checked={form.terms} onChange={onChange} />
            <span className="checkbox__box"><Check width={12} height={12} /></span>
            <span>
              I agree to the <Link to="/terms" target="_blank" rel="noopener noreferrer">Terms of Service</Link> and <Link to="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
            </span>
          </label>
          {errors.terms && <p className="fld__error" role="alert">{errors.terms}</p>}
        </div>

        <p className="auth__note">
          Your email is never shown to other users. It is shared only after an admin
          assigns a delivery.
        </p>

        <SubmitButton loading={loading}>{loading ? 'Creating account…' : 'Create account'}</SubmitButton>
      </form>
    </AuthLayout>
  );
}
